import { defineStore } from "pinia";
import { ViewportState } from "@/stores/viewport/types.ts";
import { isDesktop, isMobileAny } from "@/util/viewportUtil.ts";

const useViewportStore = defineStore("viewport", {
  state: (): ViewportState => ({
    innerHeight: 0,
    innerWidth: 0,
  }),
  actions: {
    resize(payload: { innerWidth: number; innerHeight: number }) {
      const { innerWidth, innerHeight } = payload;
      this.innerWidth = innerWidth;
      this.innerHeight = innerHeight;
    },
  },
  getters: {
    isMobile: (state) =>
      isMobileAny({ w: state.innerWidth, h: state.innerHeight }),
    isDesktop: (state) =>
      isDesktop({ w: state.innerWidth, h: state.innerHeight }),
  },
});

export { useViewportStore };
